import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { api, ApiError } from '@/lib/axios'

type ResetApplicationPasswordRequest = {
  password: string
  verifyToken: string
}

async function resetApplicationPasswordRequest(
  id: string,
  { password, verifyToken }: ResetApplicationPasswordRequest,
  token: string,
) {
  const { data } = await api.backend.post(
    `/application-account-users/reset-password/${id}`,
    {
      password,
      verifyToken,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  )
  return data
}

export function useResetApplicationPassword() {
  const { mutateAsync, isPending } = useMutation<
    unknown,
    AxiosError<ApiError>,
    { id: string; password: string; verifyToken: string; token: string }
  >({
    mutationKey: ['/application-account-users/reset-password'],
    mutationFn: ({ id, password, verifyToken, token }) =>
      resetApplicationPasswordRequest(id, { password, verifyToken }, token),
  })

  const handleResetApplicationPassword = async (
    id: string,
    password: string,
    verifyToken: string,
    token: string,
  ) => {
    return mutateAsync({ id, password, verifyToken, token })
  }

  return { handleResetApplicationPassword, isResettingPassword: isPending }
}
